module.exports = __webpack_public_path__ + "img/product_mb_us_eu_au_fr_de.6b95df6.svg";